import { StripeCardNumberElementOptions } from '@stripe/stripe-js';
import { getParameterFromURL } from '../../../../../../../../../utils/scripts';

const darkTheme = getParameterFromURL('darkTheme') === 'true';

export const getCardFieldOptions = (placeholder?: string, disabled = false): StripeCardNumberElementOptions => ({
  style: {
    base: {
      fontSize: '17px',
      fontWeight: 700,
      color: darkTheme ? '#fffbf2' : '#231E19',
      '::placeholder': {
        color: '#AAA59F',
        fontSize: '15px',
      },
    },
    invalid: {
      color: darkTheme ? '#fffbf2' : '#231E19',
    },
  },
  placeholder,
  disabled,
});
